import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { User } from '@spartacus/core';
import { NavigationUIComponent } from '@spartacus/storefront';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Observable } from 'rxjs';

import { FADE_IN_CONTENT_BY_HEIGHT_OPACITY } from '@app/core/constants/animations.constant';

@Component({
    selector: 'dp-my-account-ui',
    templateUrl: './my-account-ui.component.html',
    styleUrl: './my-account-ui.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [FADE_IN_CONTENT_BY_HEIGHT_OPACITY],
    standalone: false
})
export class DpMyAccountUiComponent extends NavigationUIComponent {
  userAccountData$ = inject(UserAccountFacade).get() as Observable<User>;
}
